import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { About } from "@/components/About";
import { Platform } from "@/components/Platform";
import { Events } from "@/components/Events";
import { Volunteer } from "@/components/Volunteer";
import { Donate } from "@/components/Donate";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useLenis();
  return (
    <div className="grain bg-[#050505] text-white">
      <Navbar />
      <Hero />
      <MarqueeStrip />
      <About />
      <Platform />
      <Events />
      <Volunteer />
      <Donate />
      <Footer />
    </div>
  );
}
